module.exports = __webpack_public_path__ + "img/shopping-cart.387ab966.svg";